// Generated by purs version 0.15.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Halogen_Store_Monad from "../Halogen.Store.Monad/index.js";
import * as PartyCarlo_Data_Log from "../PartyCarlo.Data.Log/index.js";
import * as PartyCarlo_Pages_Home_Logs from "../PartyCarlo.Pages.Home.Logs/index.js";
import * as PartyCarlo_Store from "../PartyCarlo.Store/index.js";
import * as PartyCarlo_Utils from "../PartyCarlo.Utils/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
var runStoreT = /* #__PURE__ */ Halogen_Store_Monad.runStoreT(Effect_Aff.monadAff);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var humanString = /* #__PURE__ */ PartyCarlo_Data_Log.humanString(PartyCarlo_Pages_Home_Logs.displayHomeLog);
var ProdM = function (x) {
    return x;
};
var runProdM = function (store) {
    var $23 = runStoreT(store)(PartyCarlo_Store.reduce);
    return function ($24) {
        return $23(coerce($24));
    };
};
var monadStoreProdM = /* #__PURE__ */ Halogen_Store_Monad.monadStoreStoreT(Effect_Aff.monadEffectAff);
var getStore = /* #__PURE__ */ Halogen_Store_Monad.getStore(monadStoreProdM);
var monadProdM = /* #__PURE__ */ Halogen_Store_Monad.monadStoreT(Effect_Aff.monadAff);
var monadEffectProdM = /* #__PURE__ */ Halogen_Store_Monad.monadEffectStoreT(Effect_Aff.monadEffectAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(monadEffectProdM);
var nowProdM = {
    now: /* #__PURE__ */ liftEffect(Effect_Now.now),
    nowDate: /* #__PURE__ */ liftEffect(Effect_Now.nowDate),
    nowTime: /* #__PURE__ */ liftEffect(Effect_Now.nowTime),
    nowDateTime: /* #__PURE__ */ liftEffect(Effect_Now.nowDateTime),
    Monad0: function () {
        return monadProdM;
    }
};
var randomProdM = {
    random: /* #__PURE__ */ liftEffect(PartyCarlo_Utils.randomEff),
    MonadEffect0: function () {
        return monadEffectProdM;
    }
};
var monadAffProdM = /* #__PURE__ */ Halogen_Store_Monad.monadAffStoreT(Effect_Aff_Class.monadAffAff);
var sleepProdM = {
    sleep: /* #__PURE__ */ (function () {
        var $25 = Effect_Aff_Class.liftAff(monadAffProdM);
        return function ($26) {
            return $25(Effect_Aff.delay($26));
        };
    })(),
    MonadAff0: function () {
        return monadAffProdM;
    }
};
var functorProdM = /* #__PURE__ */ Halogen_Store_Monad.functorStoreT(Effect_Aff.functorAff);
var bindProdM = /* #__PURE__ */ Halogen_Store_Monad.bindStoreT(Effect_Aff.bindAff);
var bind = /* #__PURE__ */ Control_Bind.bind(bindProdM);
var applyProdM = /* #__PURE__ */ Halogen_Store_Monad.applyStoreT(Effect_Aff.applyAff);
var applicativeProdM = /* #__PURE__ */ Halogen_Store_Monad.applicativeStoreT(Effect_Aff.applicativeAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeProdM);
var logMessagesProdM = {
    logMessage: function (log) {
        var logToConsole = function (f) {
            return function (log$prime) {
                return liftEffect(f(humanString(log$prime)));
            };
        };
        return bind(getStore)(function (store) {
            var v = PartyCarlo_Data_Log.level(log);
            if (store.env instanceof PartyCarlo_Store.Prod && v instanceof PartyCarlo_Data_Log.Debug) {
                return pure(Data_Unit.unit);
            };
            if (v instanceof PartyCarlo_Data_Log.Debug) {
                return logToConsole(Effect_Console.debug)(log);
            };
            if (v instanceof PartyCarlo_Data_Log.Info) {
                return logToConsole(Effect_Console.info)(log);
            };
            if (v instanceof PartyCarlo_Data_Log.Warn) {
                return logToConsole(Effect_Console.warn)(log);
            };
            if (v instanceof PartyCarlo_Data_Log["Error"]) {
                return logToConsole(Effect_Console.error)(log);
            };
            throw new Error("Failed pattern match at PartyCarlo.ProdM (line 50, column 9 - line 56, column 55): " + [ store.env.constructor.name, v.constructor.name ]);
        });
    },
    Monad0: function () {
        return monadProdM;
    }
};
export {
    ProdM,
    runProdM,
    functorProdM,
    applyProdM,
    applicativeProdM,
    bindProdM,
    monadProdM,
    monadEffectProdM,
    monadAffProdM,
    monadStoreProdM,
    nowProdM,
    logMessagesProdM,
    randomProdM,
    sleepProdM
};
